export interface ISelection {
  id: string;
  item: any;
  checked: boolean;
  disabled?: boolean;
}
